import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'siq-access-group-filters',
  templateUrl: './access-group-filters.component.html',
  styleUrls: ['./access-group-filters.component.scss']
})
export class AccessGroupFiltersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
